import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Poligon } from "app/models/poligon.model";
import { PoligonService } from "app/services/poligon.service";
import { ToasterService } from "app/services/user-interaction/services/toaster.service";
import { BaseFormComponent } from "../../base-form.component";

@Component({
    selector: 'app-zone-update',
    templateUrl: './zone-update.component.html',
    styleUrls: ['./zone-update.component.scss']
})
export class ZoneUpdateComponent extends BaseFormComponent implements OnInit {
    private _poligon:Poligon;
    
    public get model() {
        return this._poligon
    }
    public set model(v: Poligon) {
        this._poligon = v;
    }

    constructor(private _toasterService:ToasterService,private _polygonService:PoligonService,private _translateService:TranslateService) {
        super();
    }

    public ngOnInit(){

    }

    public async save(){
        if (this.form.invalid) {
            this._toasterService.toastWarning(
                this._translateService.instant("PLEASE_FILL_IN_THE_FORM_CORRECTLY")
            );
            return;
        }
        
        if(this.model.treshold <0){
            this._toasterService.toastWarning("Konteyner toplama eşiği 0'dan küçük olamaz");
            return;
        }

        this.model.status=true;
        try {
            await this._polygonService.update(this.model);
            this.updated.emit(true);
        } catch (error) {
            console.warn(error);
            this.updated.emit(false);
        }
    }
}